export default {"src":"/evde-internet/_next/static/media/infoCircle.c1a32bbd.svg","height":36,"width":37};